export class HlPercentageRangeRequest{
    Grade : number;
    
    constructor(Grade : number)
    {
        this.Grade = Grade;
        
    }
}
